import { LegalLayout } from "./LegalLayout";
import { OPERATOR } from "../../../shared/constants";

// 利用規約(スキャフォールドの雛形。正式版は運営で確定)。
export function TermsPage() {
  return (
    <LegalLayout title="利用規約">
      <p className="muted">
        本利用規約（以下「本規約」）は、{OPERATOR.companyName}（以下「当社」）が提供する
        {OPERATOR.serviceName}（以下「本サービス」）の利用条件を定めるものです。
      </p>
      <h2>第1条（適用）</h2>
      <p>本規約は、利用者と当社との間の本サービスの利用に関わる一切に適用されます。</p>
      <h2>第2条（アカウント登録）</h2>
      <p>
        利用者は、正確かつ最新の情報で登録するものとし、パスワードを適切に管理する責任を負います。
      </p>
      <h2>第3条（料金および支払い）</h2>
      <p>
        料金は表示された税込総額とし、支払いは銀行振込によります。デザイン提案までは無料です。
      </p>
      <h2>第4条（AIクレジット）</h2>
      <p>
        AIクレジットは前払式で、有効期限は付与から6ヶ月です。原則として払い戻しはできません。
      </p>
      <h2>第5条（禁止事項）</h2>
      <p>法令違反、当社または第三者の権利侵害、本サービスの運営妨害等を禁止します。</p>
      <h2>第6条（免責）</h2>
      <p>
        当社は、本サービスに関して利用者に生じた損害について、当社の故意または重過失による場合を除き責任を負いません。
      </p>
      <h2>第7条（規約の変更）</h2>
      <p>当社は、必要と判断した場合、利用者への通知のうえ本規約を変更できます。</p>
      <p className="muted small">※ 本文はスキャフォールドの雛形です。</p>
    </LegalLayout>
  );
}
